export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        // Register a focus directive
        Vue.directive('focus', {
            // When the bound element is inserted into the DOM...
            update: function (el) {
                // Focus the element
                el.focus()
            }
        });

    }
}
